import { hasPermission } from "./permissions";
import config from "../../config";

export default function redirectRoute(Router) {
	const authorizedRoutes = [];
	const authorizedListingRoutes = [];

	if (Router.options && Router.options.routes) {
		const routes = Router.options.routes;

		routes.forEach(route => {
			if (route.meta && route.meta.rule) {
				const routeRules = route.meta.rule;

				if (hasPermission(routeRules)) {
					if (route.name) {
						authorizedRoutes.push(route.name);

						if (/listar$/.test(route.name)) {
							authorizedListingRoutes.push(route.name);
						}
					}
				}
			}
		});
	}

	const iCanSeeHomePage = authorizedRoutes.includes(
		config.homePageRouteName
	);

	if (iCanSeeHomePage) {
		Router.push({ name: config.homePageRouteName });
	} else if (authorizedListingRoutes.length) {
		Router.push({ name: authorizedListingRoutes[0] });
	} else if (authorizedRoutes.length) {
		Router.push({ name: authorizedRoutes[0] });
	} else {
		Router.push({ name: "logout" });
	}
}
